import axiosInstance from '../../../core/api/axios';
import { ICourseSSRExam } from '../models/Revision.model';
import { SSRResponseDTO } from '../models/SSRListDTO';

export async function getAllSSRsByCourse(
  slug: string
): Promise<SSRResponseDTO[]> {
  try {
    const response = await axiosInstance.get(`/simulatedweek/${slug}`);

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function getCourseSSRExam(
  slug: string,
  programId: string
): Promise<ICourseSSRExam> {
  try {
    const response = await axiosInstance.post(`/simulatedweek/${slug}`, {
      programId,
    });

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function startCourseSSRExam(courseSSRId: string) {
  try {
    const response = await axiosInstance.post(
      `/simulatedweek/${courseSSRId}/start`
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function isStartedCourseSSRExam(slug: string, programId: string) {
  try {
    const response = await axiosInstance.post(
      `/simulatedweek/existSimulationWeekInCourse/${slug}`,
      { programId }
    );

    const data = response.data;

    return data.existSimulationWeekInCourse;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function finishCourseSSRExam(
  courseSSRId: string,
  questions: any
) {
  try {
    const response = await axiosInstance.post(
      `/simulatedweek/${courseSSRId}/finish`,
      { questions }
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}

export async function remakeCourseSSRExam(
  courseSSRId: string,
  courseId: string
) {
  try {
    const response = await axiosInstance.post(
      `/simulatedweek/${courseSSRId}/remake`,
      { course: courseId }
    );

    return response.data;
  } catch (e: any) {
    throw new Error(e);
  }
}
